import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { UniversalDialogForRouter } from 'console/dialogs/universal';
import { SearchField } from 'shared/components/fields/search';
import { useState } from 'react';
import { keyboard_shortcuts_data } from '../model/keyboard-shortcuts-data';
import { KeyboardShortcutsList } from 'pages/keyboard-shortcuts/ui/keyboard-shortcuts-list';
import { filterShortcutsList } from 'pages/keyboard-shortcuts/lib/fiter-shortcuts-list';
export function KeyboardShortcutsPage() {
    const [searchValue, setSearchValue] = useState('');
    const filtered_list = filterShortcutsList(searchValue, keyboard_shortcuts_data);
    return (_jsxs(UniversalDialogForRouter, { title: "\u0413\u043E\u0440\u044F\u0447\u0438\u0435 \u043A\u043B\u0430\u0432\u0438\u0448\u0438", fullWidth: true, children: [_jsx(SearchField, { value: searchValue, onChange: setSearchValue, onClear: () => {
                    setSearchValue('');
                }, sx: { my: 4 } }), _jsx(Box, { display: "flex", flexWrap: "wrap", gap: "20px", justifyContent: "space-between", minHeight: "600px", children: searchValue ? (_jsx(KeyboardShortcutsList, { keyboard_shortcuts_data: filtered_list })) : (_jsx(KeyboardShortcutsList, { keyboard_shortcuts_data: keyboard_shortcuts_data })) })] }));
}
